{
  "title": "Find Traps",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level divination",
  "level": 2,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You sense the presence of any trap within range that is within line of sight.",
    "A trap, for the purpose of this spell, includes anything that would inflict a sudden or unexpected effect you consider harmful or undesirable, which was specifically intended as such by its creator. Thus, the spell would sense an area affected by the alarm spell, a glyph of warding, or a mechanical pit trap, but it would not reveal a natural weakness in the floor, an unstable ceiling, or a hidden sinkhole.",
    "This spell merely reveals that a trap is present. You don’t learn the location of each trap, but you do learn the general nature of the danger posed by a trap you sense."
  ],
  "spellLists": ["cleric", "druid", "ranger"]
}
